/**
 * THIS MONTH — what the firm used, as Leveri counts it (ADR-0022): clients
 * Leveri prepared work for, the work and versions behind them, and a hosted
 * model's readings. What it would cost at list price is shown beside it, so
 * value is tested from day one; during the private beta nothing is charged.
 * Every figure is the server's; this page adds nothing up.
 */
import { useEffect, useState } from "react";
import { FirmUsageResponse } from "@leveri/contracts";
import { Figure, Notice, Section, SectionHead } from "../file/index.js";
import { call, failureMessage } from "../api.js";

export function UsageSection() {
  const [usage, setUsage] = useState<FirmUsageResponse | null>(null);
  const [failure, setFailure] = useState<string | null>(null);
  useEffect(() => {
    call("GET", "/api/firm/usage", FirmUsageResponse).then(setUsage).catch((error) => setFailure(failureMessage(error)));
  }, []);
  if (failure) return <Section><SectionHead>This month</SectionHead><Notice>{failure}</Notice></Section>;
  if (!usage) return null;
  const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;
  return (
    <Section>
      <SectionHead>This month</SectionHead>
      <p className="-mt-2 mb-4 text-[13px] text-stone">{usage.monthLabel} · {usage.standing}</p>
      <div data-testid="usage">
        <Figure first label="Clients Leveri prepared work for" citation="what Leveri charges for, one a month per client" value={String(usage.clientMonths)} />
        <Figure label="Pieces of work" citation={plural(usage.versions, "version prepared", "versions prepared")} value={String(usage.works)} />
        <Figure label="Readings by a model" citation={usage.readings.tokensText} value={String(usage.readings.count)} />
        <Figure total label={`At list price · ${usage.listPrice.planName} plan`} citation={`${usage.listPrice.includedClientMonths} clients a month included`} value={usage.listPrice.amountText} />
      </div>
      <p className="mt-3 text-[13px] leading-relaxed text-stone">
        Leveri charges for work done, never for people. Questions, answers, corrections, preparing again and reviews are always free.
      </p>
    </Section>
  );
}
